module.exports = function () {
  return {
    $get: ['$rootScope', function ($rootScope) {
      const eventListener = {
        /**
         * 让传入的模态框响应浏览器返回按钮点击关闭
         * @description 主要的实现思路是利用history.pushState往历史记录栈手动压入一条空白记录（压入弹出都不会导致页面切换），并通过监听popstate事件来响应返回按钮点击操作
         * @param {*} modal 传入的模态框引用
         * @param {string} type 如何关闭模态框,未传入关闭模态框关闭函数将根据此值决定如何关闭,默认remove
         * @param {*} modalCloseFunc 传入的模态框关闭函数，该参数存在的原因是具体的模态框关闭场景可能会有业务逻辑
         */
        prepareModalBack: function (modal, type = 'remove', modalCloseFunc) {
          $rootScope.backModal = null
          $rootScope.backAction = null
          $rootScope.backModalCloseFunc = null
          $rootScope.backModal = modal
          $rootScope.backAction = type
          $rootScope.backModalCloseFunc = modalCloseFunc
          // 添加一条空白的历史记录到history对象中
          if (window.history && window.history.pushState) {
            window.history.pushState({}, '')
          }
          // 移除已有的popstate事件监听器
          window.removeEventListener('popstate', window.backClickListener)
          // 响应浏览器返回按钮点击的回调函数
          window.backClickListener = function (e) {
            if ($rootScope.backModal && $rootScope.backAction === 'remove') {
              if ($rootScope.backModalCloseFunc) {
                $rootScope.backModalCloseFunc()
              } else {
                $rootScope.backModal.remove()
              }
            }
            if ($rootScope.backModal && $rootScope.backAction === 'hide') {
              if ($rootScope.backModalCloseFunc) {
                $rootScope.backModalCloseFunc()
              } else {
                $rootScope.backModal.hide()
              }
            }
          }
          // 绑定popstate事件的监听器
          window.addEventListener('popstate', window.backClickListener, false)
        },
        /**
         * 不通过浏览器返回按钮回退的操作需要在退出函数中运行该方法，移除prepareModalBack加入history的空白记录，避免出现history.go(-1)不生效的问题
         */
        endModalBack: function() {
          window.history.go(-1)
        }
      }
      return eventListener
    }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/modalFunc.js